// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/pictures/solea-logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../res/logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../res/footerStoreSelected.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../res/footerInfosSelected.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../res/footerProfileSelected.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --main-hg-color: #824bb0;
  --main-txt-secondary: #C5C5C5;
  --main-txt-primary: #4D4B48;
  --main-link-color: #BBB;
  --main-link-color-hover: #AAA;
  --footer-selected-color: #3C3C3B;
  --footer-separator-color: #DEDEDE;
  --background-svg: #F6F4F1;

  --main-width: 370px;
  --inputPadding: 1em;
  --buttonPadding: 1em;
}

body {
  font-family: Clother;
  font-weight: bold;
}

.button {
  letter-spacing: 1.2px;
  /* width: 150px !important; */
}
#headerLogo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 100%;
  height: 100%;
  transform: scale(10)
}

#footerWallet .footerPicto {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
#footerStore .footerPicto {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
#footerInfo .footerPicto {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
#footerProfile .footerPicto {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
#connectPicture {
  width: calc(100% + 10px);
  height: calc((100vw - 40px) / 3 * 2);
  margin-left: -5px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  box-shadow: -12px 22px 48px 34px rgb(90 90 90 / 15%);
  margin-bottom: 30px;
}

@media only screen and (min-width: 800px) {
  #connectPicture {
    height: 300px;
  }
}

.card-text {
  color: grey;
}

.MuiGrid-root {
  padding: 0px !important;
}

.css-1apwjuv-MuiAutocomplete-root {
  width: 250px !important;
}

.selectDropdownContainer .css-1uhhrmm-MuiAutocomplete-endAdornment {
    top: 20px !important;
}

.modalStyle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 350px;
  background-color: white;
  border: 2px solid rgb(130, 75, 176);
  border-radius: 10px;
  box-shadow: 24px;
  padding-top: 16px;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 24px;
  color: rgb(130, 75, 176);
}
`, "",{"version":3,"sources":["webpack://./src/styles/custom.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,iCAAiC;EACjC,yBAAyB;;EAEzB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,yDAA6D;EAC7D,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EAEE,mDAAkC;AACpC;AACA;EAEE,mDAAiD;AACnD;AACA;EAEE,mDAAiD;AACnD;AACA;EAEE,mDAAmD;AACrD;AACA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,iBAAiB;EACjB,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,uBAAuB;EACvB,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;AAC1B","sourcesContent":[":root {\n  --main-hg-color: #824bb0;\n  --main-txt-secondary: #C5C5C5;\n  --main-txt-primary: #4D4B48;\n  --main-link-color: #BBB;\n  --main-link-color-hover: #AAA;\n  --footer-selected-color: #3C3C3B;\n  --footer-separator-color: #DEDEDE;\n  --background-svg: #F6F4F1;\n\n  --main-width: 370px;\n  --inputPadding: 1em;\n  --buttonPadding: 1em;\n}\n\nbody {\n  font-family: Clother;\n  font-weight: bold;\n}\n\n.button {\n  letter-spacing: 1.2px;\n  /* width: 150px !important; */\n}\n#headerLogo {\n  background-image: url(\"../../public/pictures/solea-logo.svg\");\n  width: 100%;\n  height: 100%;\n  transform: scale(10)\n}\n\n#footerWallet .footerPicto {\n  -webkit-mask-image: url(\"../res/logo.svg\");\n  mask-image: url(\"../res/logo.svg\");\n}\n#footerStore .footerPicto {\n  -webkit-mask-image: url(\"../res/footerStoreSelected.svg\");\n  mask-image: url(\"../res/footerStoreSelected.svg\");\n}\n#footerInfo .footerPicto {\n  -webkit-mask-image: url(\"../res/footerInfosSelected.svg\");\n  mask-image: url(\"../res/footerInfosSelected.svg\");\n}\n#footerProfile .footerPicto {\n  -webkit-mask-image: url(\"../res/footerProfileSelected.svg\");\n  mask-image: url(\"../res/footerProfileSelected.svg\");\n}\n#connectPicture {\n  width: calc(100% + 10px);\n  height: calc((100vw - 40px) / 3 * 2);\n  margin-left: -5px;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  box-shadow: -12px 22px 48px 34px rgb(90 90 90 / 15%);\n  margin-bottom: 30px;\n}\n\n@media only screen and (min-width: 800px) {\n  #connectPicture {\n    height: 300px;\n  }\n}\n\n.card-text {\n  color: grey;\n}\n\n.MuiGrid-root {\n  padding: 0px !important;\n}\n\n.css-1apwjuv-MuiAutocomplete-root {\n  width: 250px !important;\n}\n\n.selectDropdownContainer .css-1uhhrmm-MuiAutocomplete-endAdornment {\n    top: 20px !important;\n}\n\n.modalStyle {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 350px;\n  background-color: white;\n  border: 2px solid rgb(130, 75, 176);\n  border-radius: 10px;\n  box-shadow: 24px;\n  padding-top: 16px;\n  padding-left: 32px;\n  padding-right: 32px;\n  padding-bottom: 24px;\n  color: rgb(130, 75, 176);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
